import {
    type AudioActionTypes,
    type AudioState,
    REGISTER_AUDIO_TRACK,
    REGISTER_SYSTEM_AUDIO_TRACK,
    REVOKE_AUDIO_TRACK,
    type RevokeAudioTrackAction,
    UNBLOCK_AUDIO_TRACK,
    type UnblockAudioTrackAction,
} from "../../Actions/Audio/AudioActions";
import { type ShopfrontActions } from "../../Utilities/Generic/ActionsHelper";

function revokeAudioTrack(
    state: AudioState,
    action: RevokeAudioTrackAction
): AudioState {
    const index = state.tracks.findIndex(track => track.id === action.data.id);

    return {
        ...state,
        tracks: [
            ...state.tracks.slice(0, index),
            {
                ...state.tracks[index],
                track: null,
            },
            ...state.tracks.slice(index + 1),
        ],
    };
}

function unblockAudioTrack(
    state: AudioState,
    action: UnblockAudioTrackAction
): AudioState {
    const index = state.tracks.findIndex(track => track.id === action.data.id);

    return {
        ...state,
        tracks: [
            ...state.tracks.slice(0, index),
            {
                ...state.tracks[index],
                track: action.data.track,
            },
            ...state.tracks.slice(index + 1),
        ],
    };
}

function AudioReducer(
    state: AudioState,
    action: ShopfrontActions<AudioActionTypes>
): AudioState {
    if(typeof state === "undefined") {
        return {
            systemTrack: null,
            tracks     : [],
        };
    }

    switch(action.type) {
        case REGISTER_AUDIO_TRACK:
            return {
                ...state,
                tracks: [
                    ...state.tracks,
                    action.data,
                ],
            };
        case REGISTER_SYSTEM_AUDIO_TRACK:
            return {
                ...state,
                systemTrack: action.data.id,
            };
        case REVOKE_AUDIO_TRACK:
            return revokeAudioTrack(state, action);
        case UNBLOCK_AUDIO_TRACK:
            return unblockAudioTrack(state, action);
        default:
            return state;
    }
}

export default AudioReducer;
